import axios from "axios";

const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:5001/api";

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add token to requests
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle response errors
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  },
);

// Auth API
export const authAPI = {
  register: (data) => apiClient.post("/auth/register", data),
  login: (email, password) =>
    apiClient.post("/auth/login", { email, password }),
  getCurrentUser: () => apiClient.get("/auth/me"),
  logout: () => apiClient.post("/auth/logout"),
};

// Leads API
export const leadsAPI = {
  submitLoanApplication: (data) =>
    apiClient.post("/leads/loan-application", data),
  submitCardApplication: (data) =>
    apiClient.post("/leads/card-application", data),
  submitContact: (data) => apiClient.post("/leads/contact", data),
  getLeads: (queryString) => apiClient.get(`/leads?${queryString}`),
  getLead: (id) => apiClient.get(`/leads/${id}`),
  updateLead: (id, data) => apiClient.put(`/leads/${id}`, data),
  deleteLead: (id) => apiClient.delete(`/leads/${id}`),
};

// Loans API
export const loansAPI = {
  getLoans: (filters = {}) => apiClient.get("/loans", { params: filters }),
  getLoan: (id) => apiClient.get(`/loans/${id}`),
  createLoan: (data) => apiClient.post("/loans", data),
  updateLoan: (id, data) => apiClient.put(`/loans/${id}`, data),
  deleteLoan: (id) => apiClient.delete(`/loans/${id}`),
};

// Cards API
export const cardsAPI = {
  getCards: (filters = {}) => apiClient.get("/cards", { params: filters }),
  getCard: (id) => apiClient.get(`/cards/${id}`),
  createCard: (data) => apiClient.post("/cards", data),
  updateCard: (id, data) => apiClient.put(`/cards/${id}`, data),
  deleteCard: (id) => apiClient.delete(`/cards/${id}`),
};

// Analytics API
export const analyticsAPI = {
  getLoanMetrics: (startDate, endDate) =>
    apiClient.get("/analytics/loans-metrics", {
      params: { startDate, endDate },
    }),
  getCardMetrics: (startDate, endDate) =>
    apiClient.get("/analytics/cards-metrics", {
      params: { startDate, endDate },
    }),
  getDashboardMetrics: () => apiClient.get("/analytics/dashboard-metrics"),
};

export default apiClient;
